module.exports = __webpack_public_path__ + "images/shanxi_banner01.jpg?425d50bf01ded2a3eb7672efe1c34438";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/shanxi_banner01.jpg
// module id = 190
// module chunks = 1